export const getUserSkillTreeCacheKey = (
    queryKey: string,
    skillTreeUuid: string | null,
    learningPathUuid: string | null,
    token: string
) => [queryKey, skillTreeUuid, learningPathUuid, token];

export const getSelectedLearningPathAfterSelectNode = (oldData: any, node: { uuid: string }) => {
    return {
        ...oldData?.selectedLearningPath,
        nodes: oldData?.selectedLearningPath?.nodes?.map((oldNode: any) => {
            if (oldNode.uuid === node.uuid) {
                return { ...oldNode, status: 'completed' };
            }
            return oldNode;
        })
    };
};
